import { render, staticRenderFns } from "./MasterAwb_KSA.vue?vue&type=template&id=f0b92d5a&"
import script from "./MasterAwb_KSA.vue?vue&type=script&lang=js&"
export * from "./MasterAwb_KSA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports